import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import NAVIGATION from "@/data/navigation.json";
import "@/styles/menu-mobile.css";

/* Bouton et panneau de navigation sous 1080 px. Les entrées viennent de la même
   source que le menu de bureau : navigation.json, entrée de rendez-vous comprise. */
const ENTREE_RDV = NAVIGATION.rendez_vous;
const ENTREES = [...NAVIGATION.menu, ENTREE_RDV];

/* Même destination que le bouton de bureau, lue à la même source, et même règle
   d'affichage : visible quand l'en-tête est opaque, comme `.nav-cta`. */
export function BoutonRdvMobile() {
  return (
    <Link
      to={ENTREE_RDV.to}
      className="btn btn-primary rdv-mobile"
      aria-label={ENTREE_RDV.l}
      data-testid="nav-cta-rdv-mobile"
    >
      {ENTREE_RDV.court}
    </Link>
  );
}

function Icone({ ouvert }) {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true" focusable="false">
      {ouvert
        ? <><path d="M4 4l10 10" /><path d="M14 4L4 14" /></>
        : <><path d="M2 5h14" /><path d="M2 9h14" /><path d="M2 13h14" /></>}
    </svg>
  );
}

export function MenuMobile() {
  const [ouvert, setOuvert] = useState(false);
  const bouton = useRef(null);
  const panneau = useRef(null);

  const fermer = () => {
    setOuvert(false);
    if (bouton.current) bouton.current.focus();
  };

  useEffect(() => {
    if (!ouvert) return undefined;
    const surTouche = (e) => { if (e.key === "Escape") fermer(); };
    const surClic = (e) => {
      if (panneau.current?.contains(e.target) || bouton.current?.contains(e.target)) return;
      setOuvert(false);
    };
    document.addEventListener("keydown", surTouche);
    document.addEventListener("mousedown", surClic);
    document.addEventListener("touchstart", surClic);
    return () => {
      document.removeEventListener("keydown", surTouche);
      document.removeEventListener("mousedown", surClic);
      document.removeEventListener("touchstart", surClic);
    };
  }, [ouvert]);

  return (
    <>
      <button
        type="button"
        ref={bouton}
        className="menu-mobile-bouton"
        aria-expanded={ouvert ? "true" : "false"}
        aria-controls="menu-mobile"
        onClick={() => setOuvert((v) => !v)}
        data-testid="menu-mobile-bouton"
      >
        <Icone ouvert={ouvert} />
        <span>Menu</span>
      </button>
      <div id="menu-mobile" className="menu-mobile" data-ouvert={ouvert ? "true" : "false"} ref={panneau} data-testid="menu-mobile">
        <nav aria-label="Navigation">
          {ENTREES.map((it) => (
            it.page_serveur ? (
              <a key={it.n} href={it.to} className="menu-mobile-entree" data-testid={`menu-mobile-item-${it.n}`} onClick={fermer}>
                {it.l}
              </a>
            ) : (
              <Link key={it.n} to={it.to} className="menu-mobile-entree" data-testid={`menu-mobile-item-${it.n}`} onClick={fermer}>
                {it.l}
              </Link>
            )
          ))}
        </nav>
      </div>
    </>
  );
}
